import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import App from './App'
import Error from './404'
import React from 'react'
import RegisterStorageItem from './pages/RegisterStorageItem'
import RegisterEntry from './pages/RegisterEntry'
import RegisterExit from './pages/RegisterExit'
import ViewStorage from './pages/ViewStorage'
import MovementList from './pages/MovementList'
import PendingEntry from './pages/PendingEntry'
import PendingExit from './pages/PendingExit'
import { contentPath, modules } from './config/pages'
import EditStorageItem from './pages/EditStorageItem'
import ViewStore from './pages/ViewStore'
import Forbidden from './pages/Forbidden'
import ViewContactList from './pages/ViewContactList'
import ViewSettings from './pages/ViewSettings'
import ViewMovementDetail from './pages/ViewMovementDetail'
import StockOverrideList from './pages/StockOverrideList'
import StorageReports from './pages/StorageReports'
import Traceability from './pages/Traceability'

function Routes(){
  return (
    
    <Router>
      <Switch>
        <Route exact path="/" component={App}/> 
        <Route exact path="/sorry" component={Forbidden}/> 
        <Route exact path={contentPath[modules.RegisterStorageItem]} component={RegisterStorageItem}/> 
        <Route exact path={contentPath[modules.RegisterEntry]} component={RegisterEntry}/> 
        <Route exact path={contentPath[modules.RegisterExit]} component={RegisterExit}/> 
        <Route exact path={contentPath[modules.StorageItemList]} component={ViewStorage}/> 
        <Route exact path={contentPath[modules.MovementList]} component={MovementList}/> 
        <Route exact path={contentPath[modules.PendingEntriesList]} component={PendingEntry}/> 
        <Route exact path={contentPath[modules.PendingExitsList]} component={PendingExit}/> 
        <Route exact path={contentPath[modules.StockOverrideList]} component={StockOverrideList}/> 
        <Route exact path={contentPath[modules.EditStorageItem]} component={EditStorageItem}/> 
        <Route exact path={contentPath[modules.StoreList]} component={ViewStore}/>  
        <Route exact path={contentPath[modules.ContactList]} component={ViewContactList}/>  
        <Route exact path={contentPath[modules.Settings]} component={ViewSettings}/>  
        <Route exact path={contentPath[modules.MovementDetail]} component={ViewMovementDetail}/>  
        <Route exact path={contentPath[modules.StorageReports]} component={StorageReports}/>  
        <Route exact path={contentPath[modules.Traceability]} component={Traceability}/>  
        <Route component={Error} />
      </Switch>
    </Router>
  )
}

export default Routes